
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cms/[[...cmsSlug]]",
      function () {
        return require("private-next-pages/cms/[[...cmsSlug]].page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cms/[[...cmsSlug]]"])
      });
    }
  